const initialState = {
    user: '',

    noData: false,
    users: [],
    filters: [],
    fetching: false,
    fetched: false,
    error: null
}

export function usersReducer(state = initialState, action) {

    switch (action.type) {
        case "SET_USER": {
            return { ...state, user: action.payload.data.user }
        }

        case "FETCH_USERS_LIST_TOKEN":
        case "FETCH_USERS_LIST": {
            return { ...state, fetching: true, fetched: false, error: null }
        }
        case "FETCH_USERS_LIST_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }
        case "FETCH_USERS_LIST_FULFILLED": {
            let totalActiveUsers = 0
            let totalInactiveUsers = 0

            let statusFilters = []

            action.payload.data.map((user) => {
                var date = new Date(user.lastUpdatedAt);
                user.lastUpdatedAtDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();

                if (user.isActive)
                    totalActiveUsers++
                else
                    totalInactiveUsers++
            })

            statusFilters.push({ filter: 'Active', count: totalActiveUsers })
            statusFilters.push({ filter: 'Inactive', count: totalInactiveUsers })

            return { ...state, fetching: false, fetched: true, noData: action.payload.data.length == 0, users: action.payload.data, filters: statusFilters }
        }
        case "FETCH_USER_ERROR": {
            return { ...state, error: null }
        }
        case "NODATA_ERROR_CLEAR": {
            return { ...state, noData: false }
        }

        default:
            return state
    }
}
